export const randomWeight = (min: number, max: number) => {
    const range = max - min;
    const randomBuffer = new Uint32Array(1);
    window.crypto.getRandomValues(randomBuffer);
    const randomNumber = randomBuffer[0] / (0xffffffff + 1); // Normalizando el valor
    return Math.floor(randomNumber * range) + min; // Escalando y ajustando al rango deseado
};
